import { Component, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { DialogResult } from '../../../models/modal-dialog-result';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirm-modal',
  standalone: true,
  imports: [],
  templateUrl: './approve-modal.component.html',
  styleUrl: './approve-modal.component.scss'
})
export class ApproveModalComponent {
  @Input() title: string = 'Approve?';
  @Input() message: string = 'Please confirm that you have completed the review, and you want to approve.';

  public onClose: Subject<DialogResult> = new Subject();

  constructor(public activeModal: NgbActiveModal) {
  }

  ok() {
    this.onClose.next({ result: true });
    this.activeModal.dismiss();
  }

  cancel() {
    this.onClose.next({ result: false });
    this.activeModal.dismiss();
  }
}
